// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 876) return "static/chunks/876-14538b98a5905ec0.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"196":"ee8b1517","717":"eabe11fc"}[chunkId] || chunkId) + "." + {"89":"537c888e3911ac94","167":"b4eba1266e088e33","196":"fed74bdb56aa5750","606":"9843376c3f39bd49","717":"06557c194c14f524"}[chunkId] + ".js";
};